/** CoStar.Api.Maps.Tenant.TenantPointOfInterestType */
export var TenantPointOfInterestType;
(function (TenantPointOfInterestType) {
    TenantPointOfInterestType[TenantPointOfInterestType["None"] = 0] = "None";
    TenantPointOfInterestType[TenantPointOfInterestType["Bank"] = 1] = "Bank";
    TenantPointOfInterestType[TenantPointOfInterestType["Bar"] = 2] = "Bar";
    TenantPointOfInterestType[TenantPointOfInterestType["Coffee"] = 3] = "Coffee";
    TenantPointOfInterestType[TenantPointOfInterestType["Fitness"] = 4] = "Fitness";
    TenantPointOfInterestType[TenantPointOfInterestType["Grocery"] = 5] = "Grocery";
    TenantPointOfInterestType[TenantPointOfInterestType["Restaurant"] = 6] = "Restaurant";
    TenantPointOfInterestType[TenantPointOfInterestType["Shop"] = 7] = "Shop";
})(TenantPointOfInterestType || (TenantPointOfInterestType = {}));
/** CoStar.Api.Maps.Tenant.StoreType */
export var StoreType;
(function (StoreType) {
    StoreType[StoreType["None"] = 0] = "None";
    StoreType[StoreType["EmploymentAgency"] = 1] = "EmploymentAgency";
    StoreType[StoreType["Bagel"] = 2] = "Bagel";
    StoreType[StoreType["Fitness"] = 3] = "Fitness";
    StoreType[StoreType["AutoShowroom"] = 4] = "AutoShowroom";
    StoreType[StoreType["FilmProcessing"] = 5] = "FilmProcessing";
    StoreType[StoreType["SpecialtyFoods"] = 6] = "SpecialtyFoods";
    StoreType[StoreType["CardGifts"] = 7] = "CardGifts";
    StoreType[StoreType["OtherRetail"] = 9] = "OtherRetail";
    StoreType[StoreType["IceCream"] = 10] = "IceCream";
    StoreType[StoreType["Books"] = 11] = "Books";
    StoreType[StoreType["OtherServices"] = 13] = "OtherServices";
    StoreType[StoreType["CandyNuts"] = 14] = "CandyNuts";
    StoreType[StoreType["ConsumerElectronics"] = 16] = "ConsumerElectronics";
    StoreType[StoreType["FloorCovering"] = 17] = "FloorCovering";
    StoreType[StoreType["MusicInstruments"] = 18] = "MusicInstruments";
    StoreType[StoreType["LeatherLuggagePurses"] = 19] = "LeatherLuggagePurses";
    StoreType[StoreType["Tobacco"] = 20] = "Tobacco";
    StoreType[StoreType["Automotive"] = 21] = "Automotive";
    StoreType[StoreType["GasolineStation"] = 22] = "GasolineStation";
    StoreType[StoreType["NailSalon"] = 23] = "NailSalon";
    StoreType[StoreType["SalonBarberSpa"] = 24] = "SalonBarberSpa";
    StoreType[StoreType["ChildrenApparel"] = 25] = "ChildrenApparel";
    StoreType[StoreType["CocktailBar"] = 26] = "CocktailBar";
    StoreType[StoreType["TravelAgent"] = 27] = "TravelAgent";
    StoreType[StoreType["HomeImprovement"] = 28] = "HomeImprovement";
    StoreType[StoreType["ChinaGlass"] = 29] = "ChinaGlass";
    StoreType[StoreType["Coffee"] = 30] = "Coffee";
    StoreType[StoreType["Bakery"] = 31] = "Bakery";
    StoreType[StoreType["Laundry"] = 32] = "Laundry";
    StoreType[StoreType["WindowCoverings"] = 33] = "WindowCoverings";
    StoreType[StoreType["ArtCrafts"] = 35] = "ArtCrafts";
    StoreType[StoreType["Supermarket"] = 36] = "Supermarket";
    StoreType[StoreType["DoctorDentist"] = 37] = "DoctorDentist";
    StoreType[StoreType["Florist"] = 38] = "Florist";
    StoreType[StoreType["KeyShop"] = 39] = "KeyShop";
    StoreType[StoreType["DepartmentStore"] = 40] = "DepartmentStore";
    StoreType[StoreType["OffPrice"] = 41] = "OffPrice";
    StoreType[StoreType["LadiesApparel"] = 42] = "LadiesApparel";
    StoreType[StoreType["Bank"] = 43] = "Bank";
    StoreType[StoreType["ArtGallery"] = 44] = "ArtGallery";
    StoreType[StoreType["OfficeSupply"] = 45] = "OfficeSupply";
    StoreType[StoreType["Drugstore"] = 46] = "Drugstore";
    StoreType[StoreType["LampsLighting"] = 47] = "LampsLighting";
    StoreType[StoreType["GameStore"] = 48] = "GameStore";
    StoreType[StoreType["Shoes"] = 49] = "Shoes";
    StoreType[StoreType["BowlingBilliards"] = 50] = "BowlingBilliards";
    StoreType[StoreType["Hardware"] = 52] = "Hardware";
    StoreType[StoreType["InvestmentService"] = 53] = "InvestmentService";
    StoreType[StoreType["AccountingTaxPrep"] = 56] = "AccountingTaxPrep";
    StoreType[StoreType["FastFood"] = 57] = "FastFood";
    StoreType[StoreType["HealthFood"] = 58] = "HealthFood";
    StoreType[StoreType["WirelessCommunication"] = 60] = "WirelessCommunication";
    StoreType[StoreType["Imports"] = 61] = "Imports";
    StoreType[StoreType["Newsstand"] = 62] = "Newsstand";
    StoreType[StoreType["Arcade"] = 63] = "Arcade";
    StoreType[StoreType["PetShopSupplies"] = 64] = "PetShopSupplies";
    StoreType[StoreType["FabricShop"] = 65] = "FabricShop";
    StoreType[StoreType["UnisexApparel"] = 66] = "UnisexApparel";
    StoreType[StoreType["FormalWear"] = 70] = "FormalWear";
    StoreType[StoreType["DiscountStore"] = 71] = "DiscountStore";
    StoreType[StoreType["Cinema"] = 72] = "Cinema";
    StoreType[StoreType["Accessory"] = 73] = "Accessory";
    StoreType[StoreType["Cafeteria"] = 74] = "Cafeteria";
    StoreType[StoreType["PaintWallpaper"] = 75] = "PaintWallpaper";
    StoreType[StoreType["WholesaleClub"] = 76] = "WholesaleClub";
    StoreType[StoreType["BikeShop"] = 77] = "BikeShop";
    StoreType[StoreType["FurnitureMattress"] = 78] = "FurnitureMattress";
    StoreType[StoreType["Toys"] = 79] = "Toys";
    StoreType[StoreType["HomeAccessories"] = 80] = "HomeAccessories";
    StoreType[StoreType["Photographer"] = 81] = "Photographer";
    StoreType[StoreType["ChurchCommunityHall"] = 83] = "ChurchCommunityHall";
    StoreType[StoreType["ConvenienceMarket"] = 84] = "ConvenienceMarket";
    StoreType[StoreType["OtherOffice"] = 86] = "OtherOffice";
    StoreType[StoreType["DonutShop"] = 87] = "DonutShop";
    StoreType[StoreType["Liquor"] = 88] = "Liquor";
    StoreType[StoreType["VideoGamesRental"] = 89] = "VideoGamesRental";
    StoreType[StoreType["Stationery"] = 90] = "Stationery";
    StoreType[StoreType["Insurance"] = 91] = "Insurance";
    StoreType[StoreType["BusinessCopyPostService"] = 92] = "BusinessCopyPostService";
    StoreType[StoreType["DiscountGrocer"] = 93] = "DiscountGrocer";
    StoreType[StoreType["AutomaticTellerMachine"] = 94] = "AutomaticTellerMachine";
    StoreType[StoreType["Optical"] = 96] = "Optical";
    StoreType[StoreType["ButcherFishMarket"] = 97] = "ButcherFishMarket";
    StoreType[StoreType["Candles"] = 98] = "Candles";
    StoreType[StoreType["KitchenDiningAccessories"] = 99] = "KitchenDiningAccessories";
    StoreType[StoreType["Legal"] = 100] = "Legal";
    StoreType[StoreType["Healthcare"] = 101] = "Healthcare";
    StoreType[StoreType["SportingGoods"] = 102] = "SportingGoods";
    StoreType[StoreType["MusicVidGames"] = 103] = "MusicVidGames";
    StoreType[StoreType["Hobby"] = 104] = "Hobby";
    StoreType[StoreType["GourmetMarket"] = 105] = "GourmetMarket";
    StoreType[StoreType["Cameras"] = 106] = "Cameras";
    StoreType[StoreType["Appliances"] = 107] = "Appliances";
    StoreType[StoreType["MensApparel"] = 109] = "MensApparel";
    StoreType[StoreType["Dance"] = 110] = "Dance";
    StoreType[StoreType["ShoeRepair"] = 111] = "ShoeRepair";
    StoreType[StoreType["Daycare"] = 112] = "Daycare";
    StoreType[StoreType["Cleaners"] = 114] = "Cleaners";
    StoreType[StoreType["Cookies"] = 115] = "Cookies";
    StoreType[StoreType["Pretzels"] = 116] = "Pretzels";
    StoreType[StoreType["SavingsAndLoan"] = 117] = "SavingsAndLoan";
    StoreType[StoreType["RealEstate"] = 118] = "RealEstate";
    StoreType[StoreType["NutritionCenter"] = 119] = "NutritionCenter";
    StoreType[StoreType["Restaurant"] = 120] = "Restaurant";
    StoreType[StoreType["RentalShop"] = 121] = "RentalShop";
    StoreType[StoreType["HealthAndBeautyAids"] = 122] = "HealthAndBeautyAids";
    StoreType[StoreType["JewelryWatches"] = 124] = "JewelryWatches";
    StoreType[StoreType["EyewearAccessories"] = 125] = "EyewearAccessories";
    StoreType[StoreType["AutoRental"] = 126] = "AutoRental";
    StoreType[StoreType["GardenPatioPool"] = 127] = "GardenPatioPool";
    StoreType[StoreType["CheckCashQuickLoans"] = 128] = "CheckCashQuickLoans";
    StoreType[StoreType["DrinksJuices"] = 129] = "DrinksJuices";
    StoreType[StoreType["DollarVarietyThrift"] = 130] = "DollarVarietyThrift";
    StoreType[StoreType["Marine"] = 131] = "Marine";
    StoreType[StoreType["PawnShop"] = 132] = "PawnShop";
    StoreType[StoreType["TanningSalon"] = 133] = "TanningSalon";
    StoreType[StoreType["AnimalCareGroom"] = 134] = "AnimalCareGroom";
    StoreType[StoreType["FinanceCompany"] = 135] = "FinanceCompany";
    StoreType[StoreType["HotelMotel"] = 136] = "HotelMotel";
    StoreType[StoreType["Pizza"] = 137] = "Pizza";
    StoreType[StoreType["SubSandwich"] = 138] = "SubSandwich";
    StoreType[StoreType["Yogurt"] = 139] = "Yogurt";
    StoreType[StoreType["AutoMaintenanceOilChange"] = 140] = "AutoMaintenanceOilChange";
    StoreType[StoreType["Massage"] = 141] = "Massage";
})(StoreType || (StoreType = {}));
/** CoStar.Api.Maps.Tenant.StoreTypeCategory */
export var StoreTypeCategory;
(function (StoreTypeCategory) {
    StoreTypeCategory[StoreTypeCategory["None"] = 0] = "None";
    StoreTypeCategory[StoreTypeCategory["Accessories"] = 1] = "Accessories";
    StoreTypeCategory[StoreTypeCategory["Apparel"] = 2] = "Apparel";
    StoreTypeCategory[StoreTypeCategory["Automotive"] = 3] = "Automotive";
    StoreTypeCategory[StoreTypeCategory["BuildingMaterialsHardware"] = 4] = "BuildingMaterialsHardware";
    StoreTypeCategory[StoreTypeCategory["Financial"] = 5] = "Financial";
    StoreTypeCategory[StoreTypeCategory["Food"] = 6] = "Food";
    StoreTypeCategory[StoreTypeCategory["FoodService"] = 7] = "FoodService";
    StoreTypeCategory[StoreTypeCategory["GeneralMerchandise"] = 8] = "GeneralMerchandise";
    StoreTypeCategory[StoreTypeCategory["GiftsSpecialty"] = 9] = "GiftsSpecialty";
    StoreTypeCategory[StoreTypeCategory["HealthRelated"] = 10] = "HealthRelated";
    StoreTypeCategory[StoreTypeCategory["HobbySpecialInterest"] = 11] = "HobbySpecialInterest";
    StoreTypeCategory[StoreTypeCategory["Home"] = 12] = "Home";
    StoreTypeCategory[StoreTypeCategory["OfficesNonFinancial"] = 14] = "OfficesNonFinancial";
    StoreTypeCategory[StoreTypeCategory["OtherRetail"] = 15] = "OtherRetail";
    StoreTypeCategory[StoreTypeCategory["PersonalServices"] = 16] = "PersonalServices";
    StoreTypeCategory[StoreTypeCategory["RecreationCommunity"] = 17] = "RecreationCommunity";
})(StoreTypeCategory || (StoreTypeCategory = {}));
